import { Component, Inject, OnInit } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NgStyle } from '@angular/common';
import { imageHandling } from '@shared/imageHandling';
import { Item } from '@models/localstorage.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Router } from '@angular/router';


@Component({
  selector: 'app-promo-expired',
  standalone: true,
  imports: [MatIconModule, NgStyle, MatFormFieldModule],
  templateUrl: './promo-expired.component.html',
  styleUrl: './promo-expired.component.scss'
})
export class PromoExpiredComponent implements OnInit {
  public productList: any;
  public loading: any;


  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { expiredList: any[] },
    private dialogRef: MatDialogRef<ModalComponent>,
  ) {

  }

  ngOnInit(): void {
    this.productList = [];
    this.data?.expiredList?.forEach((product: Item) => {
      const imgHa = imageHandling(product.image_url, 'small', '.webp');
      this.productList.push({ product: product, image: imgHa });
    });
  }

  public closeModal(returnToCart: boolean): void {
    if (returnToCart) {
      this.router.navigate(['/carrito']);
    }
    this.dialogRef.close();
  }

}

